export default {
  detailsLabel: '',
  howToSpendLabel: '',
  termsAndConditionsLabel: '',
  readMoreTermsConditionsLabel: '',
  expiresLabel: '',
};
